angular
	.module 'App.Component'
	.component 'tablePageInfo',
		{
			templateUrl: '@component/table/table-page-info/table-page-info.view.html'
			controller: 'TablePageInfoComponent'
			controllerAs: 'tablePageInfo'
			bindings:
				page: '<'
				pageSize: '<'
				count: '<'
				filterDTO: '<?filterDto'
		}

class TablePageInfoComponent extends AbstractController
	@registerController()

	initialize: ->
		if @filterDTO?
			if !@filterDTO instanceof FilterDTO
				throw new Error("Parameter 'filterDTO' must be NULL or instance of FilterDTO, #{typeof @filterDTO} provided")

			@$scope.$watch(
				'tablePageInfo.filterDTO'
				=>
					@page = @filterDTO.page
					@pageSize = @filterDTO.pageSize
					@count = @filterDTO.count

					@$onChanges()
				true
			)

	$onChanges: ->
		@from = (@page * @pageSize) - @pageSize + 1
		@to = Math.min(@from + @pageSize - 1, @count)
